import React from 'react';
import PropTypes from 'prop-types';
import BaseIcon from 'assets/icons/BaseIcon';

class ReservationIcon extends BaseIcon {
    render() {
        const {
            style,
            pathStyle,
        } = this.props;

        return (
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000' style={ style }>
                <path style={ pathStyle } d='M729.7 990c-143.8 0-260.3-116.6-260.3-260.3 0-143.8 116.5-260.3 260.3-260.3S990 585.9 990 729.7C990 873.4 873.5 990 729.7 990zm0-459.4c-109.9 0-199.1 89.1-199.1 199.1 0 109.9 89.1 199.1 199.1 199.1 109.9 0 199.1-89.1 199.1-199.1-.1-110-89.2-199.1-199.1-199.1zm122.5 245H699.1c-8.5 0-15.3-6.9-15.3-15.3V607.2c0-8.5 6.8-15.3 15.3-15.3h30.6c8.5 0 15.3 6.8 15.3 15.3v107.2h107.2c8.5 0 15.3 6.8 15.3 15.3v30.6c0 8.4-6.9 15.3-15.3 15.3zm-15.3-673.7c0-16.9-13.7-30.6-30.6-30.6H101.9C85 71.3 71.3 85 71.3 101.9v796.2c0 16.9 13.7 30.6 30.6 30.6h306.2V990H71.2C37.4 990 10 962.5 10 928.7V71.2C10 37.4 37.4 10 71.2 10h765.6c33.8 0 61.3 27.4 61.3 61.2v275.6h-61.3V101.9h.1zM239.7 683.7h122.5c8.4 0 15.3 6.8 15.3 15.3v30.6c0 8.4-6.9 15.3-15.3 15.3H239.7c-8.5 0-15.3-6.9-15.3-15.3V699c0-8.4 6.8-15.3 15.3-15.3zm-15.3-382.8v-30.6c0-8.5 6.9-15.3 15.3-15.3h459.4c8.5 0 15.3 6.9 15.3 15.3v30.6c0 8.4-6.8 15.3-15.3 15.3H239.7c-8.5 0-15.3-6.8-15.3-15.3zm0 214.4v-30.6c0-8.5 6.9-15.3 15.3-15.3h214.4c8.4 0 15.3 6.9 15.3 15.3v30.6c0 8.4-6.9 15.3-15.3 15.3H239.7c-8.5 0-15.3-6.9-15.3-15.3z' />
            </svg>
        );
    }
}

ReservationIcon.propTypes = {
    style: PropTypes.object,
    pathStyle: PropTypes.object,
};

export default ReservationIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/ReservationIcon.js